export const darkTheme = {
    colors: {
        primary500: '#5D1DDD',
        primary600: '#5127AC',
        primary700: '#492B8F',
        primary800: '#3A276F',
        primary900: '#2E2158',
        danger500: '#C11A0E',
        danger600: '#981F17',
        danger700: '#7E1811',
        danger800: '#651610',
        danger900: '#551B12',
        warning500: '#AD6405',
        warning600: '#9B4902',
        warning700: '#7F3205',
        warning800: '#662609',
        warning900: '#56210A',
        success500: '#0D7F49',
        success600: '#02693B',
        success700: '#015432',
        success800: '#044429',
        success900: '#033622',
        bodyBg: '$neutral900',
        hoverBg: '$neutral800',
        hoverText: '$text',
        activeBg: '$neutral800',
        activeText: '$text',
        selectedBg: '$neutral800',
        selectedText: '$text',
        surface: '#172131',
        hiContrast: '$white',
        loContrast: '$black',
        text: '$neutral200',
        textMuted: '$neutral400',
        borderColor: 'rgba(255, 255, 255, 0.1)',
        separatorColor: 'rgba(255, 255, 255, 0.1)',
        link: '$blue600',
        linkHover: '$blue600',
        linkActive: '$blue600',
        linkFocus: '$blue600',
        backdrop: 'rgba(52, 64, 84, 0.7)',
        errorText: '$danger500',
        errorBorder: '$danger500',
        primary: '$primary600',
        danger: '$danger600',
        warning: '$warning600',
        success: '$success600',
        buttonNeutralBg: '$neutral800',
        buttonNeutralBorder: '$neutral800',
        buttonNeutralText: '$text',
        buttonNeutralBgHover: '$neutral700',
        buttonNeutralBorderHover: '$neutral700',
        buttonNeutralTextHover: '$text',
        buttonNeutralBgActive: '$neutral800',
        buttonNeutralBorderActive: '$neutral800',
        buttonNeutralTextActive: '$text',
        buttonNeutralBgFocus: '$neutral800',
        buttonNeutralBorderFocus: '$neutral800',
        buttonNeutralTextFocus: '$text',
        buttonNeutralBgDisabled: '$buttonNeutralBg',
        buttonNeutralBorderDisabled: '$buttonNeutralBorder',
        buttonNeutralTextDisabled: '$buttonNeutralText',
        buttonNeutralFadedBg: 'transparent',
        buttonNeutralFadedBorder: 'transparent',
        buttonNeutralFadedText: '$textMuted',
        buttonNeutralFadedBgHover: 'transparent',
        buttonNeutralFadedBorderHover: 'transparent',
        buttonNeutralFadedTextHover: '$neutral200',
        buttonNeutralFadedBgActive: 'transparent',
        buttonNeutralFadedBorderActive: 'transparent',
        buttonNeutralFadedTextActive: '$text',
        buttonNeutralFadedBgFocus: 'transparent',
        buttonNeutralFadedBorderFocus: 'transparent',
        buttonNeutralFadedTextFocus: '$text',
        buttonNeutralFadedBgDisabled: '$buttonNeutralFadedBg',
        buttonNeutralFadedBorderDisabled: '$buttonNeutralFadedBorder',
        buttonNeutralFadedTextDisabled: '$buttonNeutralFadedText',
        buttonNeutralGhostBg: 'transparent',
        buttonNeutralGhostBorder: 'transparent',
        buttonNeutralGhostText: '$textMuted',
        buttonNeutralGhostBgHover: '$neutral800',
        buttonNeutralGhostBorderHover: '$neutral800',
        buttonNeutralGhostTextHover: '$text',
        buttonNeutralGhostBgActive: 'transparent',
        buttonNeutralGhostBorderActive: 'transparent',
        buttonNeutralGhostTextActive: '$text',
        buttonNeutralGhostBgFocus: 'transparent',
        buttonNeutralGhostBorderFocus: 'transparent',
        buttonNeutralGhostTextFocus: '$text',
        buttonNeutralGhostBgDisabled: '$buttonGhostFadedBg',
        buttonNeutralGhostBorderDisabled: '$buttonGhostFadedBorder',
        buttonNeutralGhostTextDisabled: '$buttonGhostFadedText',
        buttonNeutralLinkText: '$textMuted',
        buttonNeutralLinkTextHover: '$neutral200',
        buttonNeutralLinkTextActive: '$neutral200',
        buttonNeutralLinkTextFocus: '$neutral200',
        buttonNeutralLinkTextDisabled: '$buttonNeutralLinkText',
        buttonPrimaryBg: '$primary',
        buttonPrimaryBorder: '$primary',
        buttonPrimaryText: '$hiContrast',
        buttonPrimaryBgHover: '$primary500',
        buttonPrimaryBorderHover: '$primary500',
        buttonPrimaryTextHover: '$hiContrast',
        buttonPrimaryBgActive: '$primary',
        buttonPrimaryBorderActive: '$primary',
        buttonPrimaryTextActive: '$hiContrast',
        buttonPrimaryBgFocus: '$primary',
        buttonPrimaryBorderFocus: '$primary',
        buttonPrimaryTextFocus: '$hiContrast',
        buttonPrimaryBgDisabled: '$buttonPrimaryBg',
        buttonPrimaryBorderDisabled: '$buttonPrimaryBorder',
        buttonPrimaryTextDisabled: '$buttonPrimaryText',
        buttonPrimaryFadedBg: '$primary900',
        buttonPrimaryFadedBorder: '$primary900',
        buttonPrimaryFadedText: '$hiContrast',
        buttonPrimaryFadedBgHover: '$primary800',
        buttonPrimaryFadedBorderHover: '$primary800',
        buttonPrimaryFadedTextHover: '$hiContrast',
        buttonPrimaryFadedBgActive: '$primary900',
        buttonPrimaryFadedBorderActive: '$primary900',
        buttonPrimaryFadedTextActive: '$hiContrast',
        buttonPrimaryFadedBgFocus: '$primary900',
        buttonPrimaryFadedBorderFocus: '$primary900',
        buttonPrimaryFadedTextFocus: '$hiContrast',
        buttonPrimaryFadedBgDisabled: '$buttonPrimaryFadedBg',
        buttonPrimaryFadedBorderDisabled: '$buttonPrimaryFadedBorder',
        buttonPrimaryFadedTextDisabled: '$buttonPrimaryFadedText',
        buttonPrimaryGhostBg: 'transparent',
        buttonPrimaryGhostBorder: 'transparent',
        buttonPrimaryGhostText: '$primary400',
        buttonPrimaryGhostBgHover: '$primary900',
        buttonPrimaryGhostBorderHover: '$primary900',
        buttonPrimaryGhostTextHover: '$primary200',
        buttonPrimaryGhostBgActive: 'transparent',
        buttonPrimaryGhostBorderActive: 'transparent',
        buttonPrimaryGhostTextActive: '$primary400',
        buttonPrimaryGhostBgFocus: 'transparent',
        buttonPrimaryGhostBorderFocus: 'transparent',
        buttonPrimaryGhostTextFocus: '$primary400',
        buttonPrimaryGhostBgDisabled: '$buttonPrimaryGhostBg',
        buttonPrimaryGhostBorderDisabled: '$buttonPrimaryGhostBorder',
        buttonPrimaryGhostTextDisabled: '$buttonPrimaryGhostText',
        buttonPrimaryLinkText: '$primary400',
        buttonPrimaryLinkTextHover: '$primary200',
        buttonPrimaryLinkTextActive: '$primary200',
        buttonPrimaryLinkTextFocus: '$primary200',
        buttonPrimaryLinkTextDisabled: '$buttonPrimaryLinkText',
        buttonDangerBg: '$danger',
        buttonDangerBorder: '$danger',
        buttonDangerText: '$hiContrast',
        buttonDangerBgHover: '$danger500',
        buttonDangerBorderHover: '$danger500',
        buttonDangerTextHover: '$hiContrast',
        buttonDangerBgActive: '$danger',
        buttonDangerBorderActive: '$danger',
        buttonDangerTextActive: '$hiContrast',
        buttonDangerBgFocus: '$danger',
        buttonDangerBorderFocus: '$danger',
        buttonDangerTextFocus: '$hiContrast',
        buttonDangerBgDisabled: '$buttonDangerBg',
        buttonDangerBorderDisabled: '$buttonDangerBorder',
        buttonDangerTextDisabled: '$buttonDangerText',
        buttonDangerNeutralBg: '$danger',
        buttonDangerNeutralBorder: '$danger',
        buttonDangerNeutralText: '$hiContrast',
        buttonDangerNeutralBgHover: '$danger500',
        buttonDangerNeutralBorderHover: '$danger500',
        buttonDangerNeutralTextHover: '$hiContrast',
        buttonDangerNeutralBgActive: '$danger',
        buttonDangerNeutralBorderActive: '$danger',
        buttonDangerNeutralTextActive: '$hiContrast',
        buttonDangerNeutralBgFocus: '$danger',
        buttonDangerNeutralBorderFocus: '$danger',
        buttonDangerNeutralTextFocus: '$hiContrast',
        buttonDangerNeutralBgDisabled: '$buttonDangerNeutralBg',
        buttonDangerNeutralBorderDisabled: '$buttonDangerNeutralBorder',
        buttonDangerNeutralTextDisabled: '$buttonDangerNeutralText',
        buttonDangerFadedBg: '$danger900',
        buttonDangerFadedBorder: '$danger900',
        buttonDangerFadedText: '$danger100',
        buttonDangerFadedBgHover: '$danger800',
        buttonDangerFadedBorderHover: '$danger800',
        buttonDangerFadedTextHover: '$danger100',
        buttonDangerFadedBgActive: '$danger900',
        buttonDangerFadedBorderActive: '$danger900',
        buttonDangerFadedTextActive: '$danger100',
        buttonDangerFadedBgFocus: '$danger900',
        buttonDangerFadedBorderFocus: '$danger900',
        buttonDangerFadedTextFocus: '$danger100',
        buttonDangerFadedBgDisabled: '$buttonDangerFadedBg',
        buttonDangerFadedBorderDisabled: '$buttonDangerFadedBorder',
        buttonDangerFadedTextDisabled: '$buttonDangerFadedText',
        buttonDangerGhostBg: 'transparent',
        buttonDangerGhostBorder: 'transparent',
        buttonDangerGhostText: '$danger500',
        buttonDangerGhostBgHover: '$danger900',
        buttonDangerGhostBorderHover: '$danger900',
        buttonDangerGhostTextHover: '$danger200',
        buttonDangerGhostBgActive: 'transparent',
        buttonDangerGhostBorderActive: 'transparent',
        buttonDangerGhostTextActive: '$danger500',
        buttonDangerGhostBgFocus: 'transparent',
        buttonDangerGhostBorderFocus: 'transparent',
        buttonDangerGhostTextFocus: '$danger500',
        buttonDangerGhostBgDisabled: '$buttonDangerGhostBg',
        buttonDangerGhostBorderDisabled: '$buttonDangerGhostBorder',
        buttonDangerGhostTextDisabled: '$buttonDangerGhostText',
        buttonDangerLinkText: '$danger500',
        buttonDangerLinkTextHover: '$danger200',
        buttonDangerLinkTextActive: '$danger200',
        buttonDangerLinkTextFocus: '$danger200',
        buttonDangerLinkTextDisabled: '$buttonDangerLinkText',
        inputPlaceholder: '$textMuted',
        inputBg: '$neutral800',
        inputBorder: '$borderColor',
        inputText: '$text',
        // inputBgHover: '$surface',
        // inputBorderHover: '$borderColor',
        // inputTextHover: '$neutral900',
        inputBgActive: '$neutral800',
        inputBorderActive: '$primary',
        inputTextActive: '$text',
        inputBgFocus: '$neutral800',
        inputBorderFocus: '$primary',
        inputTextFocus: '$text',
        inputBgDisabled: '$neutral800',
        inputBorderDisabled: '$borderColor',
        inputTextDisabled: '$text',
        inputAddonBg: '$surface',
        checkboxBg: 'transparent',
        checkboxBorder: '$borderColor',
        checkboxIndicator: '$primary200',
        checkboxBgHover: '$primary900',
        checkboxBorderHover: '$primary',
        checkboxIndicatorHover: '$primary200',
        checkboxBgActive: '$primary900',
        checkboxBorderActive: '$primary',
        checkboxIndicatorActive: '$primary200',
        checkboxBgFocus: '$primary900',
        checkboxBorderFocus: '$primary',
        checkboxIndicatorFocus: '$primary200',
        checkboxBgDisabled: '$checkboxBg',
        checkboxBorderDisabled: '$checkboxBorder',
        checkboxIndicatorDisabled: '$checkboxIndicator',
        checkboxBgChecked: '$primary900',
        checkboxBorderChecked: '$primary',
        checkboxIndicatorChecked: '$primary200',
        checkboxCircleBgChecked: '$primary',
        checkboxCircleBorderChecked: '$primary',
        checkboxCircleIndicatorChecked: '$primary200',
        radioBg: 'transparent',
        radioBorder: '$borderColor',
        radioIndicator: '$primary200',
        radioBgHover: '$primary900',
        radioBorderHover: '$primary',
        radioIndicatorHover: '$primary200',
        radioBgActive: '$primary900',
        radioBorderActive: '$primary',
        radioIndicatorActive: '$primary200',
        radioBgFocus: '$primary900',
        radioBorderFocus: '$primary',
        radioIndicatorFocus: '$primary200',
        radioBgDisabled: '$radioBg',
        radioBorderDisabled: '$radioBorder',
        radioIndicatorDisabled: '$radioIndicator',
        radioBgChecked: '$primary900',
        radioBorderChecked: '$primary',
        radioIndicatorChecked: '$primary200',
        toggleBg: '$neutral800',
        toggleBorder: '$neutral800',
        toggleIndicator: '$neutral100',
        toggleBgHover: '$neutral700',
        toggleBorderHover: '$neutral700',
        toggleIndicatorHover: '$neutral800',
        toggleBgActive: '$neutral700',
        toggleBorderActive: '$neutral700',
        toggleIndicatorActive: '$neutral800',
        toggleBgFocus: '$neutral700',
        toggleBorderFocus: '$neutral700',
        toggleIndicatorFocus: '$neutral800',
        toggleBgDisabled: '$toggleBg',
        toggleBorderDisabled: '$toggleBgBorder',
        toggleIndicatorDisabled: '$toggleBgIndicator',
        toggleBgChecked: '$primary',
        toggleBorderChecked: '$primary',
        toggleIndicatorChecked: '$neutral800',
        avatarPlaceholderBg: '$neutral800',
        avatarPlaceholderText: '$textMuted',
        progressBarBg: '$neutral800',
        progressBarIndicator: 'currentColor',
        sliderTrackBg: '$neutral800',
        sliderRangeBg: '$primary',
        sliderThumbBg: '$neutral100',
        sliderThumbBorder: '$primary',
        tabsDefaultActiveTriggerText: '$text',
        tabsDefaultActiveTriggerBg: '$neutral800',
        tabsPrimaryActiveTriggerText: '$hiContrast',
        tabsPrimaryActiveTriggerBg: '$primary900',
        tabsElevatedBg: '$neutral800',
        tabsElevatedBorder: '$neutral800',
        tabsElevatedActiveTriggerText: '$text',
        tabsElevatedActiveTriggerBg: '$neutral700',
        featuredIconNeutralBg: '$neutral800',
        featuredIconNeutralDarkBg: '$neutral500',
        featuredIconNeutralBorder: '$neutral900',
        featuredIconNeutralDarkBorder: '$neutral600',
        featuredIconNeutralText: '$text',
        featuredIconPrimaryBg: '$primary800',
        featuredIconPrimaryDarkBg: '$primary500',
        featuredIconPrimaryBorder: '$primary900',
        featuredIconPrimaryDarkBorder: '$primary',
        featuredIconPrimaryText: '$primary200',
        featuredIconPrimaryMidBg: '$primary500',
        featuredIconPrimaryMidText: '$hiContrast',
        featuredIconPrimaryDarkerBg: '$primary800',
        featuredIconPrimaryDarkerText: '$hiContrast',
        featuredIconDangerBg: '$danger800',
        featuredIconDangerDarkBg: '$danger500',
        featuredIconDangerBorder: '$danger900',
        featuredIconDangerDarkBorder: '$danger',
        featuredIconDangerText: '$danger200',
        featuredIconWarningBg: '$warning800',
        featuredIconWarningDarkBg: '$warning500',
        featuredIconWarningBorder: '$warning900',
        featuredIconWarningDarkBorder: '$warning',
        featuredIconWarningText: '$warning200',
        featuredIconSuccessBg: '$success800',
        featuredIconSuccessDarkBg: '$success500',
        featuredIconSuccessBorder: '$success900',
        featuredIconSuccessDarkBorder: '$success',
        featuredIconSuccessText: '$success200',
        badgeNeutralBg: '$neutral800',
        badgeNeutralText: '$text',
        badgePrimaryBg: '$primary900',
        badgePrimaryText: '$primary200',
        badgeDangerBg: '$danger900',
        badgeDangerText: '$danger200',
        badgeWarningBg: '$warning900',
        badgeWarningText: '$warning200',
        badgeSuccessBg: '$success900',
        badgeSuccessText: '$success200',
        badgeGroupNeutralLightBg: '$neutral800',
        badgeGroupNeutralLightText: '$neutral200',
        badgeGroupNeutralLightBadgeBg: '$hiContrast',
        badgeGroupNeutralLightBadgeText: '$neutral700',
        badgeGroupNeutralMidBg: '$neutral700',
        badgeGroupNeutralMidText: '$neutral200',
        badgeGroupNeutralMidBadgeBg: '$neutral600',
        badgeGroupNeutralMidBadgeText: '$neutral200',
        badgeGroupNeutralDarkBg: '$neutral800',
        badgeGroupNeutralDarkText: '$neutral200',
        badgeGroupNeutralDarkBadgeBg: '$neutral700',
        badgeGroupNeutralDarkBadgeText: '$hiContrast',
        badgeGroupPrimaryLightBg: '$primary900',
        badgeGroupPrimaryLightText: '$primary200',
        badgeGroupPrimaryLightBadgeBg: '$hiContrast',
        badgeGroupPrimaryLightBadgeText: '$primary700',
        badgeGroupPrimaryMidBg: '$primary700',
        badgeGroupPrimaryMidText: '$primary200',
        badgeGroupPrimaryMidBadgeBg: '$primary600',
        badgeGroupPrimaryMidBadgeText: '$primary200',
        badgeGroupPrimaryDarkBg: '$primary800',
        badgeGroupPrimaryDarkText: '$primary200',
        badgeGroupPrimaryDarkBadgeBg: '$primary',
        badgeGroupPrimaryDarkBadgeText: '$hiContrast',
        badgeGroupDangerLightBg: '$danger900',
        badgeGroupDangerLightText: '$danger200',
        badgeGroupDangerLightBadgeBg: '$hiContrast',
        badgeGroupDangerLightBadgeText: '$danger700',
        badgeGroupDangerMidBg: '$danger700',
        badgeGroupDangerMidText: '$danger200',
        badgeGroupDangerMidBadgeBg: '$danger800',
        badgeGroupDangerMidBadgeText: '$danger200',
        badgeGroupDangerDarkBg: '$danger800',
        badgeGroupDangerDarkText: '$danger200',
        badgeGroupDangerDarkBadgeBg: '$danger',
        badgeGroupDangerDarkBadgeText: '$hiContrast',
        badgeGroupWarningLightBg: '$warning900',
        badgeGroupWarningLightText: '$warning200',
        badgeGroupWarningLightBadgeBg: '$hiContrast',
        badgeGroupWarningLightBadgeText: '$warning700',
        badgeGroupWarningMidBg: '$warning700',
        badgeGroupWarningMidText: '$warning200',
        badgeGroupWarningMidBadgeBg: '$warning800',
        badgeGroupWarningMidBadgeText: '$warning200',
        badgeGroupWarningDarkBg: '$warning800',
        badgeGroupWarningDarkText: '$warning200',
        badgeGroupWarningDarkBadgeBg: '$warning',
        badgeGroupWarningDarkBadgeText: '$hiContrast',
        badgeGroupSuccessLightBg: '$success900',
        badgeGroupSuccessLightText: '$success200',
        badgeGroupSuccessLightBadgeBg: '$hiContrast',
        badgeGroupSuccessLightBadgeText: '$success700',
        badgeGroupSuccessMidBg: '$success700',
        badgeGroupSuccessMidText: '$success200',
        badgeGroupSuccessMidBadgeBg: '$success800',
        badgeGroupSuccessMidBadgeText: '$success200',
        badgeGroupSuccessDarkBg: '$success800',
        badgeGroupSuccessDarkText: '$success200',
        badgeGroupSuccessDarkBadgeBg: '$success',
        badgeGroupSuccessDarkBadgeText: '$hiContrast',
        tooltipLightBg: '$surface',
        tooltipLightText: '$text',
        tooltipDarkBg: '$neutral900',
        tooltipDarkText: '$hiContrast',
        popoverBg: '$surface',
        popoverBorder: '$neutral700'
    },
    shadows: {
        xs: '0px 1px 2px rgba(0, 0, 0, 0.05)',
        sm: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)',
        md: '0px 4px 8px -2px rgba(0, 0, 0, 0.1), 0px 2px 4px -2px rgba(0, 0, 0, 0.06)',
        lg: '0px 12px 16px -4px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.03)',
        xl: '0px 20px 24px -4px rgba(0, 0, 0, 0.08), 0px 8px 8px -4px rgba(0, 0, 0, 0.03)',
        '2xl': '0px 24px 48px -12px rgba(0, 0, 0, 0.18)',
        '3xl': '0px 32px 64px -12px rgba(0, 0, 0, 0.14)',
        focusRingPrimary: '0px 1px 2px rgb(127 86 217 / 30%), 0px 0px 0px 4px rgb(88 27 233 / 13%)',
        focusRingNeutral: '0px 1px 2px rgb(255 255 255 / 8%), 0px 0px 0px 4px rgb(255 255 255 / 4%)',
        focusRingDanger: '0px 1px 2px rgb(233 27 27 / 10%), 0px 0px 0px 4px rgb(233 27 27 / 13%)'
    }
};
